export default __webpack_public_path__ + "static/phone-p-a3db7728ca81cc920f58b21a42875411.jpg";